export const sortOptions = [
  {
    name: 'Recently Started',
    value: 'createdAt',
  },
  {
    name: 'Last Started',
    value: '-createdAt',
  },
  {
    name: 'Recently Modified',
    value: 'updatedAt',
  },
  {
    name: 'Last Modified',
    value: '-updatedAt',
  },
];

export const statusOptions = [
  {
    name: 'All',
    value: null,
  },
  {
    name: 'Not Uploaded',
    value: 'not-uploaded',
  },
  {
    name: 'Completed',
    value: 'completed',
  },
];

export const pageLimitOptions = [
  {
    name: '25',
    value: 25,
  },
  {
    name: '50',
    value: 50,
  },
  {
    name: '100',
    value: 100,
  },
  {
    name: '200',
    value: 200,
  },
];
